<template>
  <div class="hearing-home">
    <div class="page-title">听力工具首页</div>
    <div class="content">
      <div class="icons" v-for="(item, index) in list" :key="index">
        <a-tooltip
          placement="topRight"
          overlayClassName="fun-tooltips"
          :title="item.tooltip"
          v-if="item.tooltip"
        >
          <img :class="`img_${index}`" :data-rlog="item.rlogKey" :src="item.img" />
        </a-tooltip>
        <img
          :class="`img_${index}`"
          v-else
          :data-rlog="item.rlogKey"
          :src="item.img"
          @click="item.click(item)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import routeController from '@/controller/router';

export default {
  components: {},
  setup() {
    const { changePage } = routeController();
    const funList = ref([
      {
        name: '生成双语字幕',
        // eslint-disable-next-line global-require
        src: require('./imgs/fun1.png'),
      },
      {
        name: '精准断句',
        // eslint-disable-next-line global-require
        src: require('./imgs/fun2.png'),
      },
      {
        name: '一键美化音质',
        // eslint-disable-next-line global-require
        src: require('./imgs/fun3.png'),
      },
      {
        name: '一次上传多端共享',
        // eslint-disable-next-line global-require
        src: require('./imgs/fun4.png'),
      },
    ]);
    const list = ref([
      {
        // eslint-disable-next-line global-require
        img: require('./imgs/irc.png'),
        path: '/hearing/hearingTask',
        rlogKey: 'marking_click',
        click(data) {
          changePage(data.path);
        },
      },
      {
        // eslint-disable-next-line global-require
        img: require('./imgs/audio.png'),
        tooltip: '功能暂未上线',
      },
      {
        // eslint-disable-next-line global-require
        img: require('./imgs/more.png'),
        tooltip: '功能暂未上线',
      },
    ]);
    return {
      list,
      funList,
    };
  },
};
</script>
<style lang="scss">
.fun-tooltips {
  background: rgba(0, 0, 0, 0.8);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  font-size: 15px;
  line-height: 18px;
  color: #fff;
  padding-bottom: 0;
  border-radius: 8px;
  .ant-tooltip-arrow {
    display: none;
  }
  .ant-tooltip-inner {
    background: rgba(0, 0, 0, 0.8);
    border-radius: 8px;
    padding: 12px 20px;
  }
}

.hearing-home {
  text-align: center;
  padding: 0 40px;
  .page-title {
    height: 100px;
    padding-top: 65px;
    color: $grey2;
    font-size: 15px;
    line-height: 18px;
    text-align: left;
    border-bottom: 1px solid $grey4;
    box-sizing: border-box;
  }
  height: 100vh;
  .functions {
    width: 600px;
    margin: 20px auto 40px;
    justify-content: space-between;
    display: flex;
    .name {
      color: $grey1;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
    }
    img {
      width: 80px;
      height: 80px;
      margin: 0 auto;
    }
  }
  .title {
    color: $grey1;
    font-weight: bold;
    font-size: 32px;
    line-height: 38px;
    margin: 50px auto 10px;
  }
  .tips {
    color: $grey2;
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;
  }
  .content {
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 820px;
    margin-top: 40px;

    img {
      width: 400px;
      height: 230px;
      margin: 0 0 20px 0;
    }
    .img_0 {
      cursor: pointer;
    }
  }
  overflow: auto;
  .top-bar {
    height: 80px;
    font-weight: 500;
    font-size: 17px;
    line-height: 20px;
    color: #898a8e;
    padding-top: 45px;
    border-bottom: 1px solid #f5f6f8;
    box-sizing: border-box;
  }
}
</style>
